import { useCallback, useEffect, useRef, useState } from 'react';
import { Button, Flex, Image, Spinner, Stack, Text, useToast } from '@chakra-ui/react';
import { SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FiMail, FiLock, FiEye, FiEyeOff } from 'react-icons/fi';

import { Input} from '../../components/Inputs/Input';
import { useAuth } from '../../hooks/auth';
import { useCart } from '../../hooks/cart';
import logoRazio from '../../assets/logoRR.png';

type SignInFormData = {
	email: string;
	password: string;
}

const signInFormSchema: yup.SchemaOf<SignInFormData> = yup.object().shape({
	email: yup.string().required('E-mail obrigatório').email('E-mail inválido'),
	password: yup.string().required('Senha obrigatória'),
}).required();

const SignIn: React.FC = () => {
  const inputRef = useRef<HTMLInputElement>(null);

	const { signIn } = useAuth();
	const { initCart } = useCart();
	const toast = useToast();

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

	const { register, handleSubmit, formState,  } = useForm<SignInFormData>({
		resolver: yupResolver(signInFormSchema),
	});

	const handleSignIn: SubmitHandler<SignInFormData> = async (data) => {
		try {
      setIsLoading(true);
			await signIn(data);
			initCart();

		} catch (error) {
			toast({
				title: 'Erro na autenticação.',
				description: 'Ocorreu um erro ao fazer login, cheque as credenciais.',
				status: 'error',
				duration: 5000,
				position: 'top-right',
				isClosable: true,
			});
		} finally {
      setIsLoading(false);
    }
	}

	return (
		<Flex
			w="100vw"
			h="100vh"
      px={4}
      pt={14}
			flexDir="column"
			align="center"
		>
      <Flex borderRadius="full"
        borderWidth={3}
        borderColor='gray.500'
        w="12.5rem"
        h="12.5rem"
        align="center"
        justify="center"
        mb={6}
      >
        <Image rounded="full" objectFit='cover' src={logoRazio} alt="RazioDigital" />
      </Flex>

			<Flex
				as="form"
				flexDir="column"
				w="100%"
				maxW="400px"
				borderRadius={8}
				onSubmit={handleSubmit(handleSignIn)}
			>
				<Stack spacing={3} align="center">
          <Text fontSize={20} fontWeight={600}>Acesse sua conta</Text>

					<Input
						// name="email"
						type="email"
						// label="E-mail"
            placeholder="E-mail"
            iconInput={FiMail}
						error={formState.errors.email}
						{...register("email")}
					/>

					<Input
						// name="password"
						type={showPassword ? "text" : "password"}
						// label="Senha"
            // iconLabel={FiLock}
            placeholder="Senha"
            iconInput={FiLock}
            iconInputRight={{
              icon: showPassword ? FiEyeOff : FiEye,
              showPassword,
              setShowPassword
            }}
						error={formState.errors.password}
						{...register("password")}
					/>
				</Stack>

				<Button
					type="submit"
					bgColor="blue.500"
          color="white"
					mt={8}
          py={7}
					//size="lg"
          rounded={10}
          isDisabled={isLoading}
				>
          {isLoading ? <Spinner color="white" /> : 'ENTRAR'}
        </Button>
			</Flex>
		</Flex>
	)
}

export default SignIn;
